var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5255 11.8696C42.4413 10.8491 41.0537 10.3591 39.6552 10.3591C38.081 10.3591 36.4912 10.9798 35.3058 12.1667L34.7972 12.6753L34.2885 12.1651C33.1031 10.9798 31.5133 10.3591 29.9391 10.3591C28.5406 10.3591 27.1531 10.8491 26.0688 11.8696C23.6841 14.1143 23.6421 17.8694 25.9413 20.1685L34.7972 29.0244L43.653 20.1685C45.9522 17.8694 45.9102 14.1143 43.5255 11.8696Z",
    fill: "#179D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2265 33.5338C50.8653 32.6113 49.2615 32.8727 47.8413 33.6924C46.4211 34.5122 38.2667 41.4843 38.2667 41.4843L30.24 41.4859C29.8666 41.4859 29.4622 41.0659 29.4622 40.6941C29.4622 40.257 29.8433 39.9163 30.24 39.9163H35.1509C36.8698 39.9163 38.7941 38.7963 38.7941 36.8051C38.7941 34.6896 36.8698 33.694 35.1509 33.694C32.1689 33.694 31.5887 33.7064 31.5887 33.7064C30.394 33.7064 29.1822 33.6349 28.2488 33.1356C27.0044 32.4978 25.5701 32.1369 24.0395 32.1369C21.4697 32.1369 19.169 33.162 17.5916 34.7782L9.21484 43.0259L18.5483 52.3593L21.6594 49.2482H37.4127C38.9808 49.2482 40.4943 48.6726 41.6657 47.6319L52.3322 35.6665C52.984 35.0878 52.9467 34.0238 52.2265 33.5338Z",
    fill: "#083E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.f1ae02d26da7ef1ae6f3423ad12260be.svg";
export { ForwardRef as ReactComponent };